import React from 'react';
import styled from 'styled-components';

// Next-step buttons under Aura's latest reply (e.g. "Send the report of … on WhatsApp" once a case is
// completed). The backend picks them from the tool that answered, so clients find features at the moment
// they need them. Tapping one sends its text as the user's message, like the chips at the top.
const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: -8px 0 16px 44px; /* line up with the bubble, past the avatar */
`;

const Step = styled.button`
  background: white;
  border: 1px solid #275386;
  border-radius: 16px;
  padding: 5px 12px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 500;
  color: #275386;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: #e7edf3;
  }

  &:focus-visible {
    outline: 2px solid #275386;
    outline-offset: 1px;
  }

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`;

const NextSteps = ({ items, onSelect, disabled }) => {
  if (!items || items.length === 0) return null;
  return (
    <Row role="group" aria-label="Suggested next steps">
      {items.map((text) => (
        <Step key={text} type="button" disabled={disabled} onClick={() => onSelect(text)}>
          {text}
        </Step>
      ))}
    </Row>
  );
};

export default NextSteps;
